<template>
  <b-field label="Buscar producto por nombre o código de barras">
    <b-autocomplete
      v-model="producto"
      id="producto"
      ref="autocomplete"
      placeholder="Escribe el nombre o el código de barras del producto"
      :keep-first="true"
      :data="productosFiltrados"
      field="nombre"
      @input="debounceBuscarProductos"
      @select="seleccionarProducto"
      size="is-large"
    >
    </b-autocomplete>
  </b-field>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2";

export default {
  name: "BuscarProducto",

  data: () => ({
    producto: "",
    productosEncontrados: [],
    debounceTimer: null,
  }),

  mounted() {
    this.ponerFocus();
  },

  methods: {
    seleccionarProducto(opcion) {
      if (!opcion) return;

      this.$emit("seleccionado", opcion);
      this.limpiarProducto();
    },

    limpiarProducto() {
      this.$nextTick(() => {
        this.producto = ""; // Limpia el campo de entrada del producto
        this.productosEncontrados = []; // Limpia la lista de productos encontrados
        document.querySelector("#producto").focus();
      });
    },

    debounceBuscarProductos() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        let payload = {
          accion: "obtener_nombre_codigo",
          producto: this.producto,
        };

        HttpService.obtenerConConsultas("productos.php", payload).then(
          (producto) => {
            this.productosEncontrados = producto;
            this.seleccionarProductoExacto();

            // Si no hay resultados, mostrar alerta roja rápida y limpiar el input
            if (this.productosFiltrados.length === 0) {
              Swal.fire({
                title: "Producto no encontrado",
                text: "El código ingresado no existe",
                icon: "error",
                toast: false, // Desactivar toast para tamaño completo
                position: "center", // Centrar la alerta
                timer: 1200,
                showConfirmButton: false,
                background: "#D32F2F", // Rojo vibrante
                color: "#fff",
                width: "600px", // Tamaño más grande (ajustable)
                grow: "row", // Expandir horizontalmente
                customClass: {
                  title: "swal-title",
                  content: "swal-text",
                },
              });

              // Limpiar el campo de búsqueda
              this.limpiarProducto();
            }
          }
        );
      }, 400);
    },

    seleccionarProductoExacto() {
      const productoExacto = this.productosFiltrados.find(
        (opcion) =>
          opcion.codigo.toString().toLowerCase() ===
          this.producto.toString().toLowerCase()
      );
      console.log(this.producto);

      if (productoExacto) {
        this.seleccionarProducto(productoExacto);
      }
    },

    ponerFocus() {
      document.querySelector("#producto").focus();
    },
  },

  computed: {
    productosFiltrados() {
      return this.productosEncontrados.filter((opcion) => {
        return (
          opcion.nombre
            .toString()
            .toLowerCase()
            .indexOf(this.producto.toLowerCase()) >= 0 ||
          opcion.codigo
            .toString()
            .toLowerCase()
            .indexOf(this.producto.toLowerCase()) >= 0
        );
      });
    },
  },
};
</script>

<style scoped>
.swal-title {
  font-size: 2rem !important; /* Doble de grande */
  font-weight: bold;
}

.swal-text {
  font-size: 1.5rem !important; /* Texto más grande */
}
</style>